var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-dinner-component" },
    [
      _c(
        "el-form",
        {
          staticClass: "config-form",
          attrs: { model: _vm.form, "label-width": "150px" },
        },
        [
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("积分设置")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "累计积分" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.pointsSwitch,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pointsSwitch", $$v)
                      },
                      expression: "form.pointsSwitch",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "switch-tip" }, [
                    _vm._v("开启后，用户消费可获得积分"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider", { staticClass: "custom-divider" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("支付设置")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "余额支付" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.balancePaySwitch,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "balancePaySwitch", $$v)
                      },
                      expression: "form.balancePaySwitch",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "switch-tip" }, [
                    _vm._v("开启后，用户可使用余额支付"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider", { staticClass: "custom-divider" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("费用设置")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "餐盒费减免" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.form.lunchBoxFeeSwitch,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "lunchBoxFeeSwitch", $$v)
                      },
                      expression: "form.lunchBoxFeeSwitch",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "switch-tip" }, [
                    _vm._v("开启后，可减免餐盒费用"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer-buttons" },
        [
          _c("el-button", { on: { click: _vm.handleReset } }, [_vm._v("重置")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.handleSave },
            },
            [_vm._v("保存配置")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }